import { Container, Row } from "reactstrap";
import LeftSidebar from "../Common/LeftSidebar";
import JobDetailsRightCards from "./JobDetailsRightCards";
import { Breadcrumbs } from "../../../../AbstractElements";
import { JobDetails, JobSearch } from "../../../../Constants/Constants";

const JobDetailsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={JobDetails} parent={JobSearch} />
      <Container fluid>
        <Row>
          <LeftSidebar />
          <JobDetailsRightCards />
        </Row>
      </Container>
    </>
  );
};
export default JobDetailsContainer;
